import { positionPublishStatus } from './SdoAdminReportHelper'
import './SdoAdminReportPositions.scss'

export default function SdoAdminReportPositions({ position }) {
    return (
        <div className='sdo-report-status__positions-info'>
            {position && position?.status && position?.status === positionPublishStatus.PUBLISHED ? 
            <i className="icon-Confirmation-circle sdo-report-status__positions-icon--published"></i> :
            <i className="icon-clock sdo-report-status__positions-icon"></i>
            }
            <div className='sdo-report-status__positions-spacing'> {position?.pos?.base} </div>
            <div>|</div>
            <div className='sdo-report-status__positions-spacing'> {position?.pos?.equipment} </div>
            <div>|</div>
            <div className='sdo-report-status__positions-spacing'> {position?.pos?.position} </div>
        </div>
    )
}
